import { useWaitForTransactionReceipt } from 'wagmi'
import { useDispatch, useSelector } from 'react-redux'

import { RedeemActions, txHashSelector } from 'features'
import { RedeemStepsE } from 'types'

const WaitAllowance = () => {
  const dispatch = useDispatch()
  const txHash = useSelector(txHashSelector)
  const { isSuccess } = useWaitForTransactionReceipt({
    hash: txHash,
  })
  if (isSuccess) {
    dispatch(RedeemActions.setCurrentStep(RedeemStepsE.SUBMIT_REDEEM))
  }
  return null
}

export { WaitAllowance }
